<template>
  <div class="ride-private-transport-list main">
    <div class="wrapper">
      <!-- <button class="delete is-large" @click="$emit('close')" /> -->
      <img :src="vehicleIcon" />
      <h1 class="subtitle" @click="$emit('close')">
        <i class="fa fa-chevron-left" style="margin-right: 6px" />
        <span>{{ $t("ride.choose-private-transport") }}</span>
      </h1>

      <RideAddPrivateTransportForm
        v-if="showAddPrivateTransport"
        @close="showAddPrivateTransport = false"
      />

      <RideNewPrivateTransportCustomer
        v-if="showNewPrivateTransportCustomer"
        @close="showNewPrivateTransportCustomer = false"
        @success="verified"
        :workflow="selected"
      />

      <div v-if="showMain">
        <div class="field">
          <p class="control has-icons-left has-icons-right">
            <input
              class="input is-info has-text-info is-rounded"
              :placeholder="$t('home2.search')"
              v-model="searchTerm"
              @focus="searchTerm = null"
              @keyup="search"
            />
            <span class="icon is-small is-left"
              ><i class="fa fa-search"
            /></span>
            <span v-show="searchTerm" class="icon is-small is-right">
              <i class="fa fa-spinner fa-spin" />
            </span>
          </p>
        </div>

        <div class="list-wrapper no-scrollbar">
          <div class="list has-text-left" style="margin-bottom: 10px">
            <span
              v-for="(t, i) in privateTransports"
              :key="i"
              class="list-item is-pointer"
              @click="selectPrivateTransport(t)"
              v-ripple
            >
              {{ shortenString(t.business.name, 35) }}
              <span v-if="t.distance < 100000" class="distance is-pulled-right">
                {{ t.distancePretty }}
              </span>
            </span>
            <span
              v-if="!privateTransports.length"
              class="list-item is-pointer"
              style="background-color: #ccc; color: black"
            >
              TUK doesn't currently have any private transport in your area.
              Please contact us if you would like to add your fleet.
            </span>
          </div>

          <div class="list">
            <span
              class="
                list-item
                has-text-grey
                is-pointer
                single-line
                no-scrollbar
              "
              @click="showAddPrivateTransport = true"
            >
              <i class="fa fa-plus-circle" />&nbsp;
              {{ $t("ride.request-to-add-your-building") }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus";
import vehicles from "@/vehicles";
import geo from "@/geo";

import RideAddPrivateTransportForm from "@/components/RideAddPrivateTransportForm.vue";
import RideNewPrivateTransportCustomer from "@/components/RideNewPrivateTransportCustomer.vue";

export default {
  components: {
    RideAddPrivateTransportForm,
    RideNewPrivateTransportCustomer,
  },
  props: {},
  data() {
    return {
      searchTerm: null,
      showAddPrivateTransport: false,
      showNewPrivateTransportCustomer: false,
      selected: null,
      tempSelected: null, // use with login callback
      loginCallback: "RIDE_PRIVATE_TRANSPORT_LOGIN_CALLBACK",
    };
  },
  computed: {
    privateTransports() {
      // TODO both "Private" and "Private Tuk Tuk"
      return this.$store.state.transport.filter((t) => {
        return t.workflow_type_name === "Private Tuk Tuk" && this.match(t);
      });
    },
    vehicleIcon() {
      return vehicles.img("Private Building");
    },
    showMain() {
      return (
        !this.showAddPrivateTransport && !this.showNewPrivateTransportCustomer
      );
    },
  },
  mounted() {
    this.sortTransports();

    EventBus.$on(this.loginCallback, () => this.selectPrivateTransport());
  },
  methods: {
    verified() {
      this.$store.commit("setPrivateTransport", this.selected);
      this.$emit("close");
    },
    selectPrivateTransport(t) {
      // added login check
      if (!t) t = this.tempSelected;
      this.tempSelected = t; // save this for use in callback
      var msg = this.$t("menu.one-last-thing");
      if (!this.smsLoginOkay(msg, this.loginCallback)) return;
      if (!this.checkMobileNumber()) return; // legacy FB/LINE logins may not have a phone number yet

      // first check if password or other info (room # etc) required
      this.selected = t; // to keep track within this component only
      if (this.checkPrivateTransportRole(t)) return;
      this.$store.commit("setPrivateTransport", t);
      setTimeout(() => this.$emit("close"), 500);
    },
    checkPrivateTransportRole(w) {
      console.log("check role for private transport workflow", w);

      var wRoles = this.$store.getters.getWorkerRoles;
      var workerRole = wRoles.find((r) => r.workflow_id === w.id);
      if (workerRole) return null; //console.log("checktuktukrole worker YAY");

      var cRoles = this.$store.getters.getCustomerRoles;
      var customerRole = cRoles.find((r) => r.workflow_id === w.id);
      console.log("customerRole", customerRole);
      if (customerRole) return null; //console.log("checktuktukrole customer YAY");

      // if does not have worker or customer role, need to create
      this.showNewPrivateTransportCustomer = true;
      return true; // means it's a new customer

      // if (w.data.requires_authentication) {
      //   this.createTukTukRoleAuth(w);
      //   return;
      // }
      // if (w.data.requires_unit_number) {
      //   this.createTukTukRoleUnitNumber(w);
      //   return;
      // }
    },
    sortTransports() {
      var userCoords = this.$store.getters.getUserLatLon;
      var transports = this.privateTransports;
      transports.forEach((t) => {
        t.distance = geo.distanceToUserInMeters(t.business, userCoords);
        t.distancePretty = geo.prettyDistance(t.distance);
      });
      transports.sort((a, b) => {
        return a.distance - b.distance;
      });
    },
    search(e) {
      this.searchTerm = e.target.value.toLowerCase(); // if (!e.target.value)
    },
    match(t) {
      return JSON.stringify(t).toLowerCase().includes(this.searchTerm);
    },
  },
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: #f5d252; */
  /* background-color: #4baced58; */
  background-color: azure;
  z-index: 21;
  /* random z-index higher than modal */
  backdrop-filter: blur(5px);
  overflow: hidden;
}
.wrapper {
  padding: 12px;
  text-align: left;
  height: 100vh;
  overflow: hidden;
}
.subtitle {
  color: black;
  opacity: 0.55;
  font-weight: 450;
  /* margin-left: 45px; */
  margin-top: 6px;
}
.delete {
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 2;
}
.fa-search {
  color: lightskyblue;
}
.key {
  font-weight: 550;
  color: rgba(84, 84, 84, 0.7);
  padding-right: 0;
}
input::-webkit-input-placeholder {
  color: #2693da !important;
  font-weight: 500;
  opacity: 0.8;
}
img {
  position: absolute;
  right: 12px;
  height: 35px;
  background-color: white;
  padding: 1px;
  border-radius: 3px;
}
.distance {
  font-size: 0.8em;
  font-weight: 550;
  opacity: 0.4;
  margin-top: 3px;
}
.list-wrapper {
  height: calc(100vh - 100px);
  overflow: auto;
  padding-bottom: 56px;
}
.list-wrapper .list {
  margin: 1px;
}
.single-line {
  max-width: 100%;
  overflow: auto;
  white-space: nowrap;
  /* text-overflow: ellipsis; */
  display: inline-block;
  vertical-align: bottom;
}
</style>